import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';

export const COLUMNS = (t, isDark, selectedItems) => [
    {
        label: t('ai_tracking.prompt_generator.googleSearchConsole.table.prompts'),
        key: 'keys',
        data: 'keys',
        sortType: 'string',
        Component: Cell,
        style: (item) => {
            const color = selectedItems?.includes(item.keys?.[0])
                ? '#eaf7f7'
                : isDark
                ? '#2a3142'
                : 'white';

            return { background: color, backgroundColor: color };
        },
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <span className="wripe">{data.join(', ')}</span>,
    },
    {
        label: t('ai_tracking.prompt_generator.googleSearchConsole.table.clicks'),
        key: 'clicks',
        data: 'clicks',
        sortType: 'number',
        Component: Cell,
        style: (item) => {
            const color = selectedItems?.includes(item.keys?.[0])
                ? '#eaf7f7'
                : isDark
                ? '#2a3142'
                : 'white';

            return { background: color };
        },
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <span className="wripe">{numeral(data).format('0,0')}</span>,
    },
    {
        label: t('ai_tracking.prompt_generator.googleSearchConsole.table.ctr'),
        key: 'ctr',
        data: 'ctr',
        sortType: 'number',
        Component: Cell,
        style: (item) => {
            const color = selectedItems?.includes(item.keys?.[0])
                ? '#eaf7f7'
                : isDark
                ? '#2a3142'
                : 'white';

            return { background: color };
        },
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <span className="wripe">{(data * 100).toFixed(2)}%</span>,
    },
    {
        label: t('ai_tracking.prompt_generator.googleSearchConsole.table.impressions'),
        key: 'impressions',
        data: 'impressions',
        sortType: 'number',
        Component: Cell,
        style: (item) => {
            const color = selectedItems?.includes(item.keys?.[0])
                ? '#eaf7f7'
                : isDark
                ? '#2a3142'
                : 'white';

            return { background: color };
        },
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <span className="wripe">{numeral(data).format('0,0')}</span>,
    },
    {
        label: t('ai_tracking.prompt_generator.googleSearchConsole.table.position'),
        key: 'position',
        data: 'position',
        sortType: 'number',
        Component: Cell,
        style: (item) => {
            const color = selectedItems?.includes(item.keys?.[0])
                ? '#eaf7f7'
                : isDark
                ? '#2a3142'
                : 'white';

            return { background: color };
        },
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <span className="wripe">{data.toFixed(2)}</span>,
    },
];
